import { useSelector } from 'react-redux';
import { Flex } from '@chakra-ui/react';

import { getFormValues } from 'redux/DataImportSlice';
import {
  ACTION_TYPE,
  DATA_TYPE,
  DATA_PERIOD,
  IMPORT_INDICATOR_TYPE,
  MULTI_INDICATOR_TYPE,
  TIME_MAPPING_TYPE,
} from 'pages/ModelOverviewPage/Import/Helper';

import ActionStepSyncOptions from '../ActionStepSyncOptions';

import RowTypeSecondStep from './MultipleIndicatorType/RowTypeSecondStep';
import SelectDimensionColumn from './SelectDimensionColumn';

const DataStepsFive = () => {
  const getFormValue = useSelector(getFormValues);
  const activeActionStep = useSelector((state: any) => state.dataImportSlice.actionSteps);
  const actionType =
    getFormValue?.dataType === DATA_TYPE.FORECAST ? ACTION_TYPE.FORECAST : ACTION_TYPE.DATA;
  return (
    <Flex w={'full'}>
      {getFormValue?.multipleIndicatorsType === MULTI_INDICATOR_TYPE.ROW &&
        getFormValue?.dataPeriod === DATA_PERIOD.MULTIPLE &&
        getFormValue?.selectedTimePeriod === TIME_MAPPING_TYPE.ROW &&
        getFormValue?.importIndicatorType === IMPORT_INDICATOR_TYPE.MULTIPLE &&
        activeActionStep === 6 && <RowTypeSecondStep getFormValue={getFormValue} />}
      {getFormValue?.multipleIndicatorsType === MULTI_INDICATOR_TYPE.ROW &&
        getFormValue?.dataPeriod === DATA_PERIOD.SINGLE &&
        getFormValue?.importIndicatorType === IMPORT_INDICATOR_TYPE.MULTIPLE &&
        activeActionStep === 5 && <RowTypeSecondStep getFormValue={getFormValue} />}

      {getFormValue?.multipleIndicatorsType === MULTI_INDICATOR_TYPE.COLUMN &&
        getFormValue?.dataPeriod === DATA_PERIOD.MULTIPLE &&
        getFormValue?.selectedTimePeriod === TIME_MAPPING_TYPE.ROW &&
        getFormValue?.importIndicatorType === IMPORT_INDICATOR_TYPE.MULTIPLE &&
        activeActionStep === 6 && <SelectDimensionColumn getFormValue={getFormValue} />}
      {getFormValue?.multipleIndicatorsType === MULTI_INDICATOR_TYPE.ROW &&
        getFormValue?.dataPeriod === DATA_PERIOD.MULTIPLE &&
        getFormValue?.selectedTimePeriod === TIME_MAPPING_TYPE.COLUMN &&
        getFormValue?.importIndicatorType === IMPORT_INDICATOR_TYPE.MULTIPLE &&
        activeActionStep === 6 && <SelectDimensionColumn getFormValue={getFormValue} />}

      {getFormValue?.multipleIndicatorsType === MULTI_INDICATOR_TYPE.COLUMN &&
        getFormValue?.dataPeriod === DATA_PERIOD.MULTIPLE &&
        getFormValue?.selectedTimePeriod === TIME_MAPPING_TYPE.COLUMN &&
        getFormValue?.importIndicatorType === IMPORT_INDICATOR_TYPE.MULTIPLE &&
        activeActionStep === 6 && <SelectDimensionColumn getFormValue={getFormValue} />}

      {getFormValue?.multipleIndicatorsType === MULTI_INDICATOR_TYPE.COLUMN &&
        getFormValue?.dataPeriod === DATA_PERIOD.SINGLE &&
        getFormValue?.importIndicatorType === IMPORT_INDICATOR_TYPE.MULTIPLE &&
        activeActionStep === 5 && <SelectDimensionColumn getFormValue={getFormValue} />}

      {/* Sync Options — last step after SelectDimensionColumn for these flows */}
      {getFormValue?.multipleIndicatorsType === MULTI_INDICATOR_TYPE.COLUMN &&
        getFormValue?.dataPeriod === DATA_PERIOD.MULTIPLE &&
        getFormValue?.selectedTimePeriod === TIME_MAPPING_TYPE.ROW &&
        getFormValue?.importIndicatorType === IMPORT_INDICATOR_TYPE.MULTIPLE &&
        activeActionStep === 7 && <ActionStepSyncOptions actionType={actionType} />}
      {getFormValue?.multipleIndicatorsType === MULTI_INDICATOR_TYPE.ROW &&
        getFormValue?.dataPeriod === DATA_PERIOD.MULTIPLE &&
        getFormValue?.selectedTimePeriod === TIME_MAPPING_TYPE.COLUMN &&
        getFormValue?.importIndicatorType === IMPORT_INDICATOR_TYPE.MULTIPLE &&
        activeActionStep === 7 && <ActionStepSyncOptions actionType={actionType} />}
      {getFormValue?.multipleIndicatorsType === MULTI_INDICATOR_TYPE.COLUMN &&
        getFormValue?.dataPeriod === DATA_PERIOD.MULTIPLE &&
        getFormValue?.selectedTimePeriod === TIME_MAPPING_TYPE.COLUMN &&
        getFormValue?.importIndicatorType === IMPORT_INDICATOR_TYPE.MULTIPLE &&
        activeActionStep === 7 && <ActionStepSyncOptions actionType={actionType} />}
      {getFormValue?.multipleIndicatorsType === MULTI_INDICATOR_TYPE.COLUMN &&
        getFormValue?.dataPeriod === DATA_PERIOD.SINGLE &&
        getFormValue?.importIndicatorType === IMPORT_INDICATOR_TYPE.MULTIPLE &&
        activeActionStep === 6 && <ActionStepSyncOptions actionType={actionType} />}
    </Flex>
  );
};

export default DataStepsFive;
